/**
 * @generated SignedSource<<5447b843a332cf64052528bf994ed449>>
 * @relayHash 79ff69131877aa1419154368816e230e
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 79ff69131877aa1419154368816e230e

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "usersToIgnore",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DumpQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DumpQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "79ff69131877aa1419154368816e230e",
    "metadata": {},
    "name": "DumpQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "c682390ab56757e693914bb797552cd2";

export default node;
